// import logo from './logo.svg';
import './App.css';
// import Container from 'react-bootstrap/Container';
// import Nav from 'react-bootstrap/Nav';
// import Navbar from 'react-bootstrap/Navbar';
import { Button, Container, Nav, Navbar } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import data from './data';
import { useState, createContext } from 'react';
import { Routes, Route, Link, useNavigate, Outlet } from 'react-router-dom';
import Detail from './Detail';
import nike from './nike';
import axios from  'axios';
import Cart from './Cart';



let context1 = createContext(); //자동으로 추가되는 메소드

function App() {
  let [shoes, setShoes] = useState(data);
  console.log(shoes[1].price)
  let navigate = useNavigate();
  let [res1, setRes1] = useState([0, 1, 2, 3, 4, 5, 6, 7, 8]);
  let [nike1, setNike1] = useState(nike);
  // let [shoes,setShoes]=useState(data);
  let [count, setCount] = useState(1);

  return (
    <div className="App">
      <Navbar bg="primary" variant="dark">
        <Container>
          <Navbar.Brand href="#home">Logo</Navbar.Brand>
          <Nav className="me-auto">
            <Nav.Link onClick={() => { navigate('/') }}>Home</Nav.Link>
            <Nav.Link onClick={() => { navigate('/detail/0') }}>Detail</Nav.Link>
            <Nav.Link onClick={() => { navigate('/cart') }}>Cart</Nav.Link>
            <Nav.Link onClick={() => { navigate('/about') }}>About</Nav.Link>
          </Nav>
        </Container>
      </Navbar>

      {/* <Link to="/">🌎Home🌎</Link>
      <Link to="/detail">⭐상세페이지⭐</Link> */}

      <Routes>
        <Route path="/" element={<Home shoes={shoes} res1={res1} setShoes={setShoes} setRes1={setRes1} nike1={nike1}/>} />
        <Route path="/detail/:id" element={
        // <context1.Provider value={{remain}}>
        <Detail shoes={shoes} />
        // </context1.Provider>
      } />
        <Route path="/cart" element={<Cart/>} />
        <Route path="/about" element={<About />} >
          <Route path="member" element={<div>Member</div>} />
          <Route path="location" element={<div>Location</div>} />
        </Route>

        {/* <Route path='*' element={<div>404 Not Founded.</div>} /> */}
      </Routes>



    </div>
  );
}

function Home(props) {
  
  return (
    <div>
      {/* 🌎메인페이지🌎 */}

      <div className='slider'></div>


      <Title/>
      <Button variant="outline-primary" onClick={() => {
        let copy = [...props.shoes].sort((a, b) => a.title > b.title ? 1 : -1);

        props.setShoes(copy);
        // props.shoes = copy;

        let res = [];
        for (let i in copy) {
          res.push(copy[i].id)
        }
        // props.setRes1(props.res1 = res);
        props.setRes(res);
      }}>이름순 정렬</Button> {''}

      <Button variant="outline-secondary" onClick={() => {
        let copy = [...props.shoes].sort((a, b) => a.price > b.price ? 1 : -1);

        props.setShoes(copy);
        // props.shoes = copy;

        let res = [];
        for (let i in copy) {
          res.push(copy[i].id)
        }
        // props.setRes1(props.res1 = res);
        props.setRes(res);
      }}>낮은가격순 정렬</Button> {''}

      <Button variant="outline-success" onClick={() => {
        let copy = [...props.shoes].sort((a, b) => a.price < b.price ? 1 : -1);

        props.setShoes(copy);
        // props.shoes = copy;

        let res = [];
        for (let i in copy) {
          res.push(copy[i].id)
        }
        // props.setRes1(props.res1 = res);
        props.setRes(res);
      }}>높은가격순 정렬</Button> {''}

      


      <Container>
        <Row>
          {props.shoes.map((v, i) => {
            return (
              <Product shoes={props.shoes[i]} i={i} res1={props.res1} />
            )
          })
          }
        </Row>
      </Container>

      <title2/>
      <Button variant="outline-success" 
      // count={count} 
      onClick={()=>{
        if (props.count === 1){
          axios.get('https://minkyung05.github.io/React_data/nike2.json').then((result)=>{
            let copy=[...props.nike1, ...result.data];
            props.setNike1(copy);
            props.setCount(2);
          })
        } else if(props.count === 2){
          axios.get('https://minkyung05.github.io/React_data/nike3.json').then((result)=>{
            let copy =[...props.nike1, result.data];
            props.setNike1(copy);
            props.setCount(3);
          })
        } else{
          alert("더이상 상품이 없습니다.");
        }
      }}> 상품 더보기</Button>{''}

      <Container style ={{marginTop:'30px'}}>
          <Row>
            {
              props.nike1.map((ele,i)=>{
                return(
                  <Nike nike1={props.nike1[i]}/>
                )
              })
            }
          </Row>
      </Container>

      <Footer/>

    </div>
  )
}


function Product(props) {
  let navigate = useNavigate();
  return (
    <Col md={4}>
      <Nav.Link onClick={() => {
        navigate('/detail/' + props.res1[props.i])
      }} className="c1">
        <img src={props.shoes.imgUrl} width='80%' alt='item' />
        <h4>{props.shoes.title}</h4>
        <p>{props.shoes.price}</p>
      </Nav.Link>
    </Col>
  )
}




function About() {
  return (
    <>
      <h4>Company Information</h4>
      <Outlet></Outlet>
    </>
  );
}

const Title = () => {
  let css1 = {
    marginTop: '70px',
    textAlign: 'center'
  }
  return (
    <>
      <h3 style={css1}>MD's Pick</h3>
      <p style={{ textAlign: 'center' }}>시선을 사로잡는 스타일링, 제품들을 만나보세요.</p>
    </>

  )
}


const Title2 = () =>{
  let css2={
    marginTop:'70px'
  }
  return(
    <>
    <h3 style={css2}>여름을 위한 컬렉션</h3>
    <p>가볍게, 시원하게 썸머 컬렉션으로 여름을 준비해보세요.</p>
    </>
  )
}

function Nike(props){
return(
  <Col md={4}>
    <img alt="item2" src={props.nike1.imgUrl} width="80%"/>
    <h5>{props.nike1.title}</h5>
    <p>{props.nike1.content}</p>
    <p>{props.nike1.price}</p>

  </Col>
)
}

function Footer(){
  let fcss ={
    backgroundColor :'#333',
    color:'#fff',
    padding: '20px 0',
    marginTop:'80px',
    marginBottom: '0'
  }
  return(
    <>
    <p style={fcss}>COPYRIGHT(C) 2022 Nike, Inc. All Rights Reserved</p>
    </>
  )
}


export default App;
